export default __webpack_public_path__ + "static/media/icon_align_small_off.a84c1f3a.svg";